import { render, staticRenderFns } from "./StepsManager.vue?vue&type=template&id=1dc0cf84"
import script from "./StepsManager.vue?vue&type=script&lang=js"
export * from "./StepsManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports